<template>
  <header-banner-layout>
    <map-banner :map-center="mapCenter" :map-zoom="mapZoom">
      <template #content>
        <div class="row">
          <div class="col-md-8 offset-md-2 foreground-content">
            <h1 class="mb-5">
              {{ title }}
            </h1>
            <location-search :distance-hint="locationSearchDistanceHint" :initial-location-query="initialLocationQuery" :lookup-url="locationLookupUrl" />
          </div>
        </div>
      </template>
    </map-banner>
  </header-banner-layout>
</template>

<script>
import GeoipCountryMixin from '@/location-search/geoip-country-mixin'
import HeaderBannerLayout from '@/components/header-banner-layout'
import LocationSearch from '@/components/inputs/locations/location-search'
import MapBanner from '@/components/map-banner'

export default {
  components: { HeaderBannerLayout, LocationSearch, MapBanner },

  mixins: [ GeoipCountryMixin ],

  props: {
    initialLocationQuery: {
      type: String,
      required: false,
      default: ''
    },
    locationLookupUrl: {
      type: String,
      required: true
    },
    locationSearchDistanceHint: {
      type: String,
      required: true
    },
    mapCenter: {
      type: Object,
      required: true
    },
    mapZoom: {
      type: Number,
      required: false
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>
